__turbopack_context__.v({
  "dot": "Loader-module__an8mxq__dot",
  "waveBounce": "Loader-module__an8mxq__waveBounce",
  "wavyLoaderContainer": "Loader-module__an8mxq__wavyLoaderContainer",
});
